var React = require('react');

function BackendDropdownMenuMailgun (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#C12126;}\n"),React.createElement("path",{"className":"st0","d":"M493,305.7c-88.9,0-161,72.1-161,161c0,88.9,72.1,161,161,161c88.9,0,161-72.1,161-161\n\tC654,377.8,582,305.7,493,305.7z M242,466.7c0-138.7,112.4-251,251-251c138.7,0,251.1,112.4,251.1,251c0,9.2-0.5,18.2-1.4,27.1\n\tc-1.9,24.5,16.1,43.2,40.4,43.2c41.3,0,45.7-53.2,45.7-70.3c0-185.4-150.3-335.6-335.6-335.6S157.4,281.4,157.4,466.7\n\tc0,185.4,150.3,335.6,335.6,335.6c98.4,0,187-42.4,248.4-109.9l69,57.9c-77.9,87.1-191.3,142-317.4,142\n\tc-235.1,0-425.7-190.6-425.7-425.7S257.9,41,493,41c235.1,0,425.7,190.6,425.7,425.7c0,94.5-45,171.2-135.4,171.2\n\tc-39.8,0-64-18.2-77.2-38.6C661.9,670.5,583,717.8,493,717.8C354.4,717.8,242,605.4,242,466.7z M493,393.1c40.7,0,73.7,33,73.7,73.7\n\tc0,40.7-33,73.7-73.7,73.7c-40.7,0-73.7-33-73.7-73.7S452.3,393.1,493,393.1z","key":1})]);
}

BackendDropdownMenuMailgun.displayName = "BackendDropdownMenuMailgun";

BackendDropdownMenuMailgun.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 1000 1000","style":{"enableBackground":"new 0 0 1000 1000"},"xmlSpace":"preserve"};

module.exports = BackendDropdownMenuMailgun;

BackendDropdownMenuMailgun.default = BackendDropdownMenuMailgun;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/menu-icons/backend-dropdown-menu-mailgun.svg
// module id = 496
// module chunks = 0